import React, { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import { Link } from "react-router-dom";
import { currencySymbol } from "shared/CurrencySymbol";
import moment from "moment";
import Badge from "shared/Badge/Badge";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export interface StayCardProps {
  className?: string;
  data?: StayDataType;
  size?: "default" | "small";
  booking?: any;
}

const DATA = DEMO_STAY_LISTINGS[0];

const StayCardV4: FC<StayCardProps> = ({
  size = "default",
  className = "",
  data = DATA,
  booking,
}) => {
  const { property } = booking;
  const {
    place_images: placeImagesTemp = property?.place_images || data.place_images,
    title = property?.title || data.title,
    href = `/booking_request?id=${booking?.id}`,
    id = property?.id || data.id,
    status = booking?.status,
    PropertyStatus = booking?.is_shared_property,
    RoomName = booking?.booked_room,
    Address = booking?.property?.address,
    roomsCount = booking?.property?.rooms_count
  } = property;
  const { currentUser } = useSelector((state: RootState) => state.user);

  const modifiedPropertyStatus = (
    PropertyStatus: string | undefined | boolean
  ) => {
    const status =
      typeof PropertyStatus === "boolean"
        ? PropertyStatus.toString()
        : PropertyStatus;
    switch (status) {
      case "true":
        return "Shared Property";
      case "false":
        return "Entire Property";
      default:
        return "";
    }
  };

  const place_images = placeImagesTemp || data.place_images;

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`StayCard_${id}`}
          ratioClass="aspect-w-4 aspect-h-3"
          galleryImgs={place_images}
          href={href}
        />
        {/* <BtnLikeIcon isLiked={like} className="absolute right-3 top-3 z-[1]" />
                {saleOff && <SaleOffBadge className="absolute left-3 top-3" />} */}
        <div className="uppercase absolute left-3 top-3 z-[1] bg-green-700 text-sm px-3 rounded-md text-white dark:text-white">
          {status}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="flex items-center space-x-2">
          <h1
            className={`font-medium capitalize text-lg`}
          >
            <span className="line-clamp-1">{title}</span>
          </h1>
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Badge
              name={modifiedPropertyStatus(PropertyStatus) || "Property"}
              className="text-xs"
            />
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"><span className="mr-2">INVOICE:</span> {size === "default" && (
              <span className="text-sm ">
                {booking?.invoice_no || 'NA'}
              </span>
            )}</span>
          </div>
        </div>
        {/* <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div> */}
        <div className="flex gap-1 items-center">
          <MapPinIcon className="w-5 h-5" />
          <div className="line-clamp-1">{size === "default" && <span className="text-sm">{Address}</span>}</div>
        </div>
        <hr />
        {(PropertyStatus === true || PropertyStatus === "true") && (
          <div className="flex items-center">
            <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              Room Name :
            </span>
            <div>
              <div className=" text-sm font-semibold line-clamp-1">
                {RoomName || "N/a"}
              </div>
            </div>
          </div>
        )}
        {(PropertyStatus !== true && PropertyStatus !== "true") && (
          <div className="flex items-center">
            <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              Total Rooms :
            </span>
            <div>
              <div className=" text-sm font-semibold line-clamp-1">
                {roomsCount || "N/a"}
              </div>
            </div>
          </div>
        )}
        {currentUser?.is_host && (
          <div className="flex items-center">
            <span className="w-[110px] flex text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              Request by :
            </span>
            {size === "default" && (
              <span className="text-sm font-semibold">
                {booking?.request_by}
              </span>
            )}
          </div>
        )}
        {/* <div className="flex justify-between items-center">
          <span className="text-sm font-semibold">
            {"$"}
            {Number(price)?.toFixed(2) || 0}
            {size === "default" && (
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                /month
              </span>
            )}
          </span>
          {!!reviewStart && (
            <StartRating reviewCount={reviewCount} point={reviewStart} />
          )}
        </div> */}
        <div className="flex items-center">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Period :
          </span>
          {size === "default" && (
            <span className="text-sm font-semibold">
      
{moment.utc(booking?.check_in_date).format("MMM DD, YYYY")} to{" "}
{moment.utc(booking?.check_out_date).format("MMM DD, YYYY")}
            </span>
          )}
        </div>
        <div className="flex items-center">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Guest :
          </span>
          {size === "default" && (
            <span className="text-sm font-semibold">
              {booking?.number_of_guests}
            </span>
          )}
        </div>

        <div className="flex items-center">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Amount Paid :
          </span>
          {size === "default" && (
            <span className="text-sm font-semibold">
              {`${currencySymbol()} ${Number(booking?.total_amount)?.toFixed(2) || "N/A"
                }`}
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard"
    >
      {renderSliderGallery()}
      <Link to={href}>{renderContent()}</Link>
    </div>
  );
};

export default StayCardV4;
